module.exports = __webpack_public_path__ + "img/16_13.8d26c6a3.png";